import { ENERGY_EFFICIENCY_CLASSES, ENERGY_SOURCES, HEATING_TYPES, HOT_WATER_SUPPLY_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUniqueEnumList } from './schemaUniqueEnumList';

export const schemaBaubeschreibungHeizungWarmwasser = z
    .object({
        energieeffizienz: z.nativeEnum(ENERGY_EFFICIENCY_CLASSES).nullish().default(null),
        energietraeger: schemaUniqueEnumList(ENERGY_SOURCES, 'Energy sources must be unique'),
        energietraegerAndere: z.string().nullish().default(null),
        heizungsart: schemaUniqueEnumList(HEATING_TYPES, 'Heating types must be unique'),
        heizungsartAndere: z.string().nullish().default(null),
        warmwasserversorgung: z.nativeEnum(HOT_WATER_SUPPLY_TYPES).nullish().default(null),
    })
    .transform((data) => ({
        ...data,
        energietraegerAndere: data.energietraeger.includes(ENERGY_SOURCES.ANDERE) ? data.energietraegerAndere : null,
        heizungsartAndere: data.heizungsart.includes(HEATING_TYPES.ANDERE) ? data.heizungsartAndere : null,
    }));

export type SchemaBaubeschreibungHeizungWarmwasser = z.infer<typeof schemaBaubeschreibungHeizungWarmwasser>;
